module.exports = __webpack_public_path__ + "img/TechFishingBoat2_ua.b5680257.webp";